import styled from 'styled-components';

export const HeaderWrapper = styled.div`
	margin: 25px 0px 25px 0px;
	.alignTitle {
		text-align: center;
	}
`;
